import axios from 'axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {

        generateOffer(_, { jobId }) {
            return axios.post(`/api/v1/pdfs/jobs/${jobId}/offer`).then(r => r.data)
        },

        generateOrderConfirmation(_, { jobId, variantId }) {
            const params = variantId ? { variantId } : {}
            return axios.post(`/api/v1/pdfs/jobs/${jobId}/order-confirmation`, null, { params }).then(r => r.data)
        },

        generateDeliveryNote(_, { productId }) {
            return axios.post(`/api/v1/pdfs/products/${productId}/delivery-note`).then(r => r.data)
        },

        findLinkByLabel(_, { label }) {
            return axios.get(`/api/v1/links`, { params: { label } })
                .then(r => {
                    const content = r.data && r.data.content
                    if (content && content.length > 0) {
                        const link = content[0]
                        return { downloadUrl: `/downloads/${link.file}?code=${link.code}` }
                    }
                    return null
                })
        },

    }
}
